import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { BulkInviteService } from '@edtech-ui/core/services/admin-panel/bulkInvite.service';
import { ToastrService } from 'ngx-toastr';
import { ValidateTemplateResponse } from '@edtech-ui/core/models/admin-panel/bulk-invite.model';
import { Observable } from 'rxjs';



@Component({
  selector: 'app-bulk-upload-dialog',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './bulk-upload-dialog.component.html',
  styleUrl: './bulk-upload-dialog.component.scss'
})
export class BulkUploadDialogComponent {

  selectedFileName: string | null = null;
  selectedFile: File | null = null;
  isLoading = false;

  constructor(private dialogRef: MatDialogRef<BulkUploadDialogComponent>,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: { type: 'teacher' | 'student' },
    private bulkService: BulkInviteService,
  ) { }


  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files?.length) {
      this.selectedFile = input.files[0];
      this.selectedFileName = this.selectedFile.name;
    }
  }

  close() {
    this.dialogRef.close();
  }

  importFile() {
    if (!this.selectedFile) {
      this.toastr.warning('Please select a file first.');
      return;
    }
    this.isLoading = true;

    const reader = new FileReader();
    reader.onload = (e: any) => {
      const csv = e.target.result as string;
      const lines = csv.split(/\r?\n/).filter(line => line.trim() !== '');
      const headers = lines[0].split(',').map(h => h.trim());
      this.bulkService.validateTemplate(headers, this.data.type).subscribe({
        next: (validation: ValidateTemplateResponse) => {
          if (validation.Success && validation.Data.valid) {
            this.toastr.success('Template validated');
            this.bulkUpload();
          } else {
            this.isLoading = false;
            this.toastr.error(validation.Data.message || 'Validation failed.');
          }
        },
        error: () => {
          this.isLoading = false;
          this.toastr.error('Validation failed.');
        }
      });
    };

    reader.readAsText(this.selectedFile);
  }
  bulkUpload() {
    if (!this.selectedFile) return;

    const api$: Observable<any> =
      this.data.type === 'teacher'
        ? this.bulkService.bulkInviteTeachers(this.selectedFile)
        : this.bulkService.bulkInviteStudents(this.selectedFile);
    api$.subscribe({
      next: (res: any) => {
        this.isLoading = false;

        if (res.Success) {
          const d = res.Data;
          this.toastr.success(
            `Processed: ${d.total_processed}, Success: ${d.successful_invites}, Duplicates: ${d.duplicate_invites}`
          );
          this.dialogRef.close(true);
        } else {
          this.toastr.error(res.Message || 'Bulk upload failed.');
        }
      },
      error: () => {
        this.isLoading = false;
        this.toastr.error('Something went wrong while uploading.');
      }
    });
  }

  downloadTemplate() {
    const teacherHeaders = ['Honorific', 'Name', 'Email', 'Department', 'Designation'];
    const studentHeaders = ['Name', 'Email', 'Batch', 'Department'];
    const headers = this.data.type === 'teacher' ? teacherHeaders : studentHeaders;
    const filename =
    this.data.type === 'teacher' ? 'teacher_template.csv' : 'student_template.csv';
    const csvContent = headers.join(',') + '\n';
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, filename);
    this.toastr.success(`${this.data.type} CSV template downloaded!`);
  }
}
